/* Dauber HQ analytics — auto-bind data-track attributes.
 * Pushes to window.dataLayer (populated by GTM in Phase 8).
 * Until GTM is wired, events log to console in dev only.
 */

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function track(eventName, params) {
    var payload = Object.assign({ event: eventName }, params || {});
    window.dataLayer.push(payload);
    if (window.location.hostname.indexOf('ddev.site') !== -1) {
      console.log('[analytics]', payload);
    }
  }

  // Auto-bind clicks on [data-track] elements
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track]');
    if (!el) return;
    var eventName = el.getAttribute('data-track');
    if (!eventName) return;

    var params = {};
    Array.prototype.forEach.call(el.attributes, function (attr) {
      if (attr.name.indexOf('data-track-') === 0 && attr.name !== 'data-track') {
        params[attr.name.replace('data-track-', '')] = attr.value;
      }
    });
    if (el.tagName === 'A' && el.href) params.link_url = el.href;
    if (el.tagName === 'A' && el.textContent) params.link_text = el.textContent.trim().slice(0, 80);

    track(eventName, params);
  });

  // Expose for manual calls
  window.dhqTrack = track;
})();
